import { render, staticRenderFns } from "./og-whatsapp.vue?vue&type=template&id=592ef116&scoped=true"
import script from "./og-whatsapp.vue?vue&type=script&lang=js"
export * from "./og-whatsapp.vue?vue&type=script&lang=js"
import style0 from "./og-whatsapp.vue?vue&type=style&index=0&id=592ef116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592ef116",
  null
  
)

export default component.exports